import {Injectable} from '@angular/core';
import {Subject} from "rxjs/internal/Subject";
import {Observable} from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})

export class SendComponentsArrayService {
  private messageSource = new Subject<number>();
  constructor() { }

  sendCompArray(data: any) {
    //
    this.messageSource.next(data);
  }
  getCompArray(): Observable<any>{
    return this.messageSource.asObservable();
  }

}

